import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconCashOut = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "-1.5 -1.69 22 22",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		"data-name": "Icon - Cash Out Sm",
		transform: "translate(0 0)",
		children: /* @__PURE__ */ _jsxs("g", {
			"data-name": "Group 4808",
			transform: "translate(0 0)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					"data-name": "Path 7603",
					d: "M10.933,6.353a2.623,2.623,0,0,0-2.2-1.039c-1.347,0-2.433.814-2.433,1.83S7.391,8.963,8.738,8.963s2.443.826,2.443,1.829-1.1,1.83-2.443,1.83a2.621,2.621,0,0,1-2.2-1.039",
					transform: "translate(0.407 0.343)",
					fill: "none",
					stroke: "currentColor",
					strokeWidth: 1.5
				}),
				/* @__PURE__ */ _jsx("line", {
					"data-name": "Line 1595",
					y1: 1.701,
					transform: "translate(9.145 3.443)",
					fill: "none",
					stroke: "currentColor",
					strokeWidth: 1.5
				}),
				/* @__PURE__ */ _jsx("line", {
					"data-name": "Line 1596",
					y1: 2.048,
					transform: "translate(9.145 13.13)",
					fill: "none",
					stroke: "currentColor",
					strokeWidth: 1.5
				}),
				/* @__PURE__ */ _jsx("path", {
					"data-name": "Path 7604",
					d: "M16.261,12.127l2.647-3.188L16.261,5.75",
					transform: "translate(1.05 0.371)",
					fill: "none",
					stroke: "currentColor",
					strokeWidth: 1.5
				}),
				/* @__PURE__ */ _jsx("line", {
					"data-name": "Line 1597",
					x1: 5.686,
					transform: "translate(14.272 9.31)",
					fill: "none",
					stroke: "currentColor",
					strokeWidth: 1.5
				}),
				/* @__PURE__ */ _jsx("path", {
					"data-name": "Path 7605",
					d: "M15.077,3.416a8.246,8.246,0,1,0,0,11.662",
					transform: "translate(0.065 0.064)",
					fill: "none",
					stroke: "currentColor",
					strokeWidth: 1.5
				})
			]
		})
	})
});
export { SvgIconCashOut as ReactComponent };
